import React from "react";
import { View, Text } from "@react-pdf/renderer";
import Styles from "../Styles";

const Lines = ({ styles, count = 2 }) => (
  <View>
    {Array.from({ length: count }).map((_, i) => (
      <View key={i} style={{ ...styles.line, marginBottom: 5 }} />
    ))}
  </View>
);

const CardSet = ({ styles }) => (
  <View style={{ ...styles.row }}>
    <View style={styles.fieldColNumber}>
      <Text style={styles.ButtonTextSmall}>Card Name</Text>
      <Lines styles={styles} count={4} />
    </View>

    <View style={styles.fieldColNumber}>
      <Text style={styles.ButtonTextSmall}>Number</Text>
      <Lines styles={styles} count={4} />
    </View>

    <View style={styles.fieldColExpiry}>
      <Text style={styles.ButtonTextSmall}>Expiry Date</Text>
      <Lines styles={styles} count={4} />
    </View>
  </View>
);

const CreditCardsSection = ({ primaryColor = "081e56" }) => {
  const styles = Styles(primaryColor);

  return (
    <View style={{ ...styles.FlexStartColumn, gap: 0 }}>
        <Text style={styles.ContentSemiBold}>Credit Cards</Text>
      <View style={styles.panel}>

        <CardSet styles={styles} />
        {/* <View style={styles.row}>
        <CardSet styles={styles} />
      </View> */}
      </View>
    </View>
  );
};

export default CreditCardsSection;
